import { render, staticRenderFns } from "./dong10.vue?vue&type=template&id=5cf91b90&scoped=true&"
import script from "./dong10.vue?vue&type=script&lang=js&"
export * from "./dong10.vue?vue&type=script&lang=js&"
import style0 from "./dong10.vue?vue&type=style&index=0&id=5cf91b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf91b90",
  null
  
)

export default component.exports